import styled from "styled-components"

export const AffiliateLine = styled.p`

`;